import React from 'react';
import { motion } from 'framer-motion';
import { Clock, AlertCircle, CheckCircle2 } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="bg-nightDeep py-12" data-id="element-199">
      <div className="max-w-5xl mx-auto px-6" data-id="element-200">
        <div className="max-w-2xl mx-auto mb-8" data-id="element-201">
          <div className="glass border-red-500/30 rounded-2xl p-6 text-center" style={{
          borderColor: 'rgba(239,68,68,0.3)'
        }} data-id="element-202">
            <div className="flex items-center justify-center gap-2 text-red-400 font-bold text-xl mb-2" data-id="element-203">
              <Clock className="w-6 h-6" data-id="element-204" />
              PRECIO DE LANZAMIENTO
            </div>
            <p className="text-white font-medium mb-4 flex items-center justify-center gap-2" data-id="element-205">
              <AlertCircle className="w-5 h-5 text-red-400" data-id="element-206" />
              Después sube $10.000 ARS. No vuelve.
            </p>
            <div className="w-full bg-white/10 rounded-full h-3 mb-2 overflow-hidden" data-id="element-207">
              <motion.div initial={{
              width: 0
            }} whileInView={{
              width: '72%'
            }} viewport={{
              once: true
            }} transition={{
              duration: 1,
              delay: 0.5
            }} className="bg-red-500 h-3 rounded-full" data-id="element-208"></motion.div>
            </div>
            <p className="text-sm text-red-400 font-bold" data-id="element-209">
              🔴 72% de los cupos al precio de lanzamiento ya tomados
            </p>
          </div>
        </div>

        <h2 className="text-3xl md:text-4xl font-bold text-center text-white mb-8" data-id="element-210">
          ELEGÍ TU COLECCIÓN
        </h2>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto" data-id="element-211">
          {/* Base Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="glass rounded-3xl p-8 flex flex-col relative" data-id="element-212">
            <div className="text-center mb-6 pb-6 border-b border-white/10" data-id="element-213">
              <h3 className="text-2xl font-bold text-white mb-2" data-id="element-214">
                📘 COLECCIÓN BASE
              </h3>
              <p className="text-textLight font-medium" data-id="element-215">6 Tomos + 6 Bonos</p>
            </div>

            <div className="text-center mb-8" data-id="element-216">
              <p className="text-xl text-textLight/70 line-through decoration-red-400 mb-1" data-id="element-217">
                $89.000
              </p>
              <p className="text-5xl font-bold text-white mb-2" data-id="element-218">
                $19.990 <span className="text-2xl" data-id="element-219">ARS</span>
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-220">
              <li className="flex items-center gap-3 text-white" data-id="element-221">
                <CheckCircle2 className="w-5 h-5 text-gold-accent flex-shrink-0" data-id="element-222" />
                <span data-id="element-223">Los 6 Tomos Completos</span>
              </li>
              <li className="flex items-center gap-3 text-white" data-id="element-224">
                <CheckCircle2 className="w-5 h-5 text-gold-accent flex-shrink-0" data-id="element-225" />
                <span data-id="element-226">Los 6 Bonos Exclusivos</span>
              </li>
            </ul>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtcGR5gY46xHK2dK4UqNG/es-ar?_r=AQABw5ZcyHnPWzbkFPYt-XxWxAHJ1loDHKYYqHQJdUs8y4U&cart_link_id=ZO9PHgFE&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-white/10 hover:bg-white/20 border border-white/20 text-white font-bold text-lg py-4 rounded-xl transition-colors" data-id="element-227">
              → QUIERO MI COLECCIÓN
            </a>
          </motion.div>

          {/* Pro Plan */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="glass rounded-3xl p-8 flex flex-col relative md:-translate-y-4 border-2 shadow-[0_0_50px_rgba(224,178,76,0.2)]" style={{
          borderColor: '#E0B24C'
        }} data-id="element-228">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-accent text-night font-bold px-4 py-1 rounded-full text-sm tracking-wide whitespace-nowrap shadow-md" data-id="element-229">
              ⭐ MÁS ELEGIDA
            </div>

            <div className="text-center mb-6 pb-6 border-b border-white/10" data-id="element-230">
              <h3 className="text-2xl font-bold text-gold-accent mb-2" data-id="element-231">
                🏆 COLECCIÓN + PRO
              </h3>
              <p className="text-textLight font-medium" data-id="element-232">
                6 Tomos + 6 Bonos + Manual Pro
              </p>
            </div>

            <div className="text-center mb-8" data-id="element-233">
              <p className="text-xl text-textLight/70 line-through decoration-red-400 mb-1" data-id="element-234">
                $119.000
              </p>
              <p className="text-5xl font-bold text-white mb-2" data-id="element-235">
                $27.990 <span className="text-2xl" data-id="element-236">ARS</span>
              </p>
            </div>

            <ul className="space-y-4 mb-8 flex-1" data-id="element-237">
              <li className="flex items-center gap-3 text-white" data-id="element-238">
                <CheckCircle2 className="w-5 h-5 text-gold-accent flex-shrink-0" data-id="element-239" />
                <span data-id="element-240">Todo lo de la Colección Base</span>
              </li>
              <li className="flex items-start gap-3 text-white bg-gold-accent/10 p-3 rounded-lg border border-gold-accent/30" data-id="element-241">
                <CheckCircle2 className="w-5 h-5 text-gold-accent flex-shrink-0 mt-0.5" data-id="element-242" />
                <span className="font-bold text-gold-accent" data-id="element-243">
                  Manual Secretaria Virtual Pro (Contratos, Cobros, Escalado)
                </span>
              </li>
            </ul>

            <a href="https://www.bibliotecasdigitales.store/checkouts/cn/hWNBtcc5gQMviKiNAt4F1mGw/es-ar?_r=AQAB9MQu5iuNkd59BCbXucAS8Tqairno5W_7ASEfkqp3m44&cart_link_id=t8H58Iw6&preview_theme_id=154123698339" target="_blank" rel="noopener noreferrer" className="block text-center w-full bg-gold-btn hover:bg-gold-btnHover text-night font-bold text-lg py-4 rounded-xl transition-colors shadow-[0_0_30px_rgba(224,178,76,0.4)]" data-id="element-244">
              → QUIERO LA COLECCIÓN + PRO
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}